import "./modules/sliders";
import './modules/jquery.selectric.js'

import AOS from 'aos';

AOS.init({
	duration: 700,
	once: true
});

// Set Viewport Width (vw) Variable
new ResizeObserver(function(){
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', vw + 'px');
  if(document.getElementById('alert-bar')) {
	 document.documentElement.style.setProperty('--alert-bar-height', document.getElementById('alert-bar').clientHeight + 'px');
  }
}).observe(document.documentElement);


// Sticky header
const headerEl = document.getElementById('site-header');
const sentinelEl = document.getElementById('header-sentinel');
const handler = (entries) => {
	if (!entries[0].isIntersecting) {
		headerEl.classList.add('sticky-header');
	} else {
		headerEl.classList.remove('sticky-header');
	}
};
const observer = new IntersectionObserver(handler);
observer.observe(sentinelEl);



// Scrollspy
var dontSpy = false;
var scrollTimeout;

if(document.querySelector('.sticky-nav-target')) {
	function anchorObserverCallback(entries, observer){
		entries.forEach((entry) => {
			const activeItems = document.querySelectorAll('.sticky-jump-nav li a[href="#' + entry.target.id + '"]');
			if(entry.isIntersecting && !dontSpy) {
				document.querySelectorAll('.sticky-jump-nav li a').forEach(el => {
					el.classList.remove('active');
				});
				activeItems.forEach(el => {
					el.classList.add('active');
				});
			}
		});
	}
	const anchorObserver = new IntersectionObserver(anchorObserverCallback, {rootMargin: "-50% 0px"});
	document.querySelectorAll('.sticky-nav-target').forEach(el => {
		anchorObserver.observe(el);
	});
}

const anchorLinks = document.querySelectorAll('.sticky-jump-nav a');
anchorLinks.forEach(lnk => {
	lnk.addEventListener('click', () => {
		clearTimeout(scrollTimeout);
		dontSpy = true;
		document.querySelectorAll('.sticky-jump-nav li a').forEach(el => {
			el.classList.remove('active');
		});
		lnk.classList.add('active');
		scrollTimeout = setTimeout(() => {
			dontSpy = false;
		}, 1000);
	});
});


// Document Ready
jQuery(function($){

	// Selectric
	$('select').selectric({
		nativeOnMobile: false,
	});

	// Email disclaimer popup
	$('.email-link').click(function(e){
		e.preventDefault();
		let disclaimerModal = $('#email-disclaimer');
		let emailAddress = $(this).data('email');
		disclaimerModal.find('.confirm-link').attr('href', 'mailto:' + emailAddress);
		disclaimerModal.modal('show');
	});


	// Scroll to top button
	var scrollDistance = 20;
	var scrollTopButton = $('.scroll-to-top-btn');
	$(window).scroll(function() {
		if ($(window).scrollTop() > scrollDistance) {
			scrollTopButton.removeClass('hidden');
		} else {
			scrollTopButton.addClass('hidden');
		}
	}).trigger('scroll');

	// Scroll to next section button
	$('.btn-scroll-to-next').on('click', function(e){
		e.preventDefault();
		$('.home-hero').next()[0].scrollIntoView();
	});


	// Header Searchform
	$('.header-searchform .search-submit').on('click', function(e){
		e.preventDefault();
		let theForm = $(this).closest('form');
		if(!theForm.hasClass('active')) {
			$('body').addClass('search-expanded');
			theForm.addClass('active');
			setTimeout(function(){
				theForm.find('.search-keyword').focus();
			}, 300);
		} else {
			if(theForm.find('.search-keyword').val().trim() == '') {
				$('body').removeClass('search-expanded');
				theForm.removeClass('active');
			} else {
				theForm.submit();
			}
		}
	});


	// Click outside
	$(window).on('click', function(){
		$('.header-searchform').removeClass('active');
		$('.selectric-like-wrapper').removeClass('selectric-open');
	});
	$('.header-searchform, .selectric-like-wrapper').on('click', function(event){
		event.stopPropagation();
	});


	// Mobile menu
	$('.header-menu-toggle').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('body').toggleClass('menu-expanded');
		$('.header-menu').fadeToggle(100);
		$('.header-menu-toggle i').toggleClass('fa-bars').toggleClass('fa-xmark');
		if( $('body').hasClass('menu-expanded') ){
			$('.header-searchform').addClass('active');
		} else {
			$('.header-searchform').removeClass('active');
		}
	});

	// Mobile sticky jump nav
	$('.sticky-jump-nav a, .mobile-toggle-jump-nav').on('click', function(e){
		if($(window).innerWidth() < 1200) {
			e.preventDefault();
			let hsn = $(this).closest('.sticky-jump-nav');
			if(hsn.hasClass('expanded')) {
				let target = $(this).attr('href');
				if(target) {
					document.querySelector(target).scrollIntoView({
					  behavior: 'smooth'
					});
				}
			}
			hsn.toggleClass('expanded');
		}
	});
	$('.sticky-jump-nav a, .mobile-toggle-jump-nav').on('click', function(event){
	  event.stopPropagation();
	});
	$(window).on('click', function() {
		$('.sticky-jump-nav').removeClass('expanded');
	});

	// Expand / Collapse All button
	$('.expand-all-button').on('click', function(e){
		e.preventDefault();
		let groupID = $(this).data('group');
		if($(this).hasClass('expanded-all')) {
			$(groupID).find('.collapse').collapse('hide');
			$(this).removeClass('expanded-all');
		} else {
			$(groupID).find('.collapse').collapse('show');
			$(this).addClass('expanded-all');
		}
	});


	// Global hero filter
	$('.hero-filters').on('change', 'select', function(){
		$('.hero-filters').submit();
	});

	$('.ajax-filters').on('submit', function(e){
		e.preventDefault();
		let target = $(this).attr('action');
		let fieldsData = $(this).find("select, input[type='search']").filter(function() {
			return $.trim(this.value).length > 0
		}).serialize();
		if(fieldsData) {
			target = target + '?' + fieldsData;
			$('#clear-all-filters').addClass('is-active');

			let keywordField = $(this).find('[name="keyword"]');
			$('.clear-filter-btns-wrap [data-field="keyword"]').remove();
			if(keywordField.val()) {
				$('.clear-filter-btns-wrap').append(`<button data-field="keyword" type="button" class="btn btn-xs btn-white">Keyword: ${keywordField.val()}<i class="fa-sharp fa-regular fa-xmark"></i></button>`);
			}

			$('.featured-posts-band').addClass('d-none');
		} else {
			$('.clear-filter-btns-wrap').empty();
			$('#clear-all-filters').removeClass('is-active');
			$('.featured-posts-band').removeClass('d-none');
		}
		window.history.replaceState('', '', target);



		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);
		holder.addClass('is-loading').append('<div class="loading-animation"><div></div></div>');



		$.get(target, function(response){
			let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			let entries = $(response).find(holderSelector).children();
			holder.html(entries).removeClass('is-loading');
			if( vw < 1200 ){
				$('html, body').animate({
					scrollTop: $('.hero').first().offset().top + $('.hero').outerHeight() - $('#site-header').outerHeight()
				}, 250);
			}
		});
	});

	$('.ajax-filters').on('change', 'select', function(){
		let attrName = $(this).attr('name');
		let value = $(this).val();
		$('.clear-filter-btns-wrap .btn[data-field="'+ attrName +'"]').remove();
		if(value) {
			let label = $(this).children(':selected').text();
			if(attrName == 'by-letter') {
				label = 'Alphabetical: ' + label;
			}
			$('.clear-filter-btns-wrap').prepend(`<button data-field="${attrName}" type="button" class="btn btn-xs btn-white">${label} <i class="fa-sharp fa-regular fa-xmark"></i></button>`);
		}
	});

	$('.clear-filter-btns-wrap').on('click', 'button', function(e){
		e.preventDefault();
		let theForm = $('.ajax-filters');
		let targetName = $(this).data('field');
		theForm.find('select[name="'+targetName+'"]').val('').selectric('refresh');
		theForm.find('input[name="'+targetName+'"]').val('');
		$(this).remove();
		theForm.submit();
	});

	$('#clear-all-filters').on('click', function(){
		let theForm = $('.hero-filters');
		theForm.find('select').val('').selectric('refresh');
		theForm.find('input[type="search"], input[type="text"]').val('');
		theForm.submit();
	});

	// Sitewide Search filter
	$('.hero-search-results').on('click', '.filter-item button', function(e){
		e.preventDefault();
		let selectedVal = $(this).data('value');
		$('.hero-search-results select[name="by-type"]').val(selectedVal).trigger('change').selectric('refresh');
	});
	$('.hero-search-results').on('change', 'select[name="by-type"]', function(){
		$('.filter-item button').removeClass('is-active');
		$('.filter-item button[data-value="'+ $(this).val() +'"]').addClass('is-active');
	});

	// Team Landing filter
	$('.alpha-list button').on('click', function(e){
		e.preventDefault();
		let selectedVal = $(this).data('value');
		$('.hero-filters select[name="by-letter"]').val(selectedVal).trigger('change').selectric('refresh');
	});
	$('.hero-filters').on('change, selectric-refresh', 'select[name="by-letter"]', function(){
		$('.alpha-list button').removeClass('is-active');
		$('.alpha-list button[data-value="'+ $(this).val() +'"]').addClass('is-active');
	});

	// Ajax next related attorneys
	$('.related-attorneys-ajax-holder').on('click', '.ajax-more-related-attorneys-btn', function(e){
		e.preventDefault();
		let thisBtnWrap = $(this).closest('.more-btn-wrap');
		let holder = $(this).closest('.related-attorneys-ajax-holder');

		let ajaxData = [
			{ name: "action", value: "next_rel_att" },
			{ name: "nonce", value: ajax_var.nonce },
			{ name: "pid", value: $(this).data('pid') },
			{ name: "paged", value: $(this).data('paged') },
		];

		thisBtnWrap.addClass('loading').append('<div class="loading-animation"><div></div></div>');

		$.ajax({
			type: "post",
			url: ajax_var.ajax_url,
			data: ajaxData,
			success: function(response){
				thisBtnWrap.remove();
				holder.append($.parseHTML(response));
			}
		});

	});
	
	// Open all external links in a new tab
	$("a[href^=http]").each(function(){
		if(this.href.indexOf(location.hostname) == -1) {
			// attach a do-nothing event handler to ensure we can 'trigger' a click on this link
			$(this).click(function() { return true; }); 
			$(this).attr({
				 target: "_blank",
				 title: "Opens in a new window"
			});
			$(this).click(); // trigger it
		}
	});

});

document.addEventListener('aos:in:ist', (event) => {
	event.detail.querySelector('a').click();
});

// Pagination
jQuery('#ajax-holder').on('click', '.ajax-more-btn-wrap a', function(e){
	e.preventDefault();
	let target = jQuery(this).attr('href');
	let thisBtnWrap = jQuery(this).closest('.ajax-more-btn-wrap');
	let holderSelector = '#ajax-holder';
	let holder = jQuery(holderSelector);

	thisBtnWrap.addClass('loading').append('<div class="loading-animation"><div></div></div>');

	jQuery.get(target, function(response){
		let entries = jQuery(response).find(holderSelector).children();
		holder.append(entries);
		thisBtnWrap.remove();
	});
});

// Video modal
document.querySelectorAll('.video-modal').forEach(el => {
	el.addEventListener('shown.bs.modal', () => {
		let vidFrame = el.querySelector('iframe');
		vidFrame.src = vidFrame.dataset.src;
	});

	el.addEventListener('hide.bs.modal', () => {
		el.querySelector('iframe').src = '';
	});
});
